import { LoadingButton } from '@mui/lab';
import { Box, Button, SxProps, Typography } from '@mui/material';

type CommonPrevNextButtonsProps = {
  onPrev?: () => void;
  onNext?: () => void;
  isPrevDisabled?: boolean;
  isNextDisabled?: boolean;
  isLoading?: boolean;
  prevText?: string;
  nextText?: string;
  /** Labels of fields still required; shown under a disabled Next button. */
  missing?: string[];
  sx?: SxProps;
};

export const CommonPrevNextButtons = ({
  isPrevDisabled,
  isNextDisabled,
  isLoading,
  onPrev,
  onNext,
  prevText = 'Prev',
  nextText = 'Next',
  missing,
  sx,
}: CommonPrevNextButtonsProps) => {
  const showMissing = !!isNextDisabled && !!missing && missing.length > 0;
  return (
    <Box sx={sx}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2,
        }}
      >
        {onPrev && (
          <Button disabled={isPrevDisabled || isLoading} onClick={onPrev}>
            {prevText}
          </Button>
        )}
        {onNext && (
          <LoadingButton
            variant="contained"
            loading={isLoading}
            disabled={isNextDisabled}
            onClick={onNext}
          >
            {nextText}
          </LoadingButton>
        )}
      </Box>
      {showMissing && (
        <Typography
          variant="caption"
          color="text.secondary"
          component="p"
          role="status"
          sx={{ textAlign: 'center', mt: 1 }}
        >
          Still needed: {missing!.join(', ')}
        </Typography>
      )}
    </Box>
  );
};
